// import React, { useState } from "react";
// import { useParams } from "react-router-dom";

// const ReturnPage = () => {

//   const { id } = useParams();

//   const [reason, setReason] = useState("");
//   const [refundType, setRefundType] = useState("wallet");

//   const handleSubmit = async () => {

//     const res = await fetch(`/api/return/${id}`, {
//       method: "POST",
//       headers: { "content-type": "application/json" },
//       body: JSON.stringify({
//         reason,
//         refundType
//       })
//     });

//     const data = await res.json();

//     if (data.success) {
//       alert("Return Request Submitted ✅");
//     }
//   };

//   return (
//     <div className="min-h-screen flex items-center justify-center px-4 py-10 relative">

//       {/* BG IMAGE */}
//       <div
//         className="absolute inset-0 bg-cover bg-center"
//         style={{
//           backgroundImage:
//             "url('https://images.unsplash.com/photo-1607082348824-0a96f2a4b9da')",
//         }}
//       />

//       <div className="absolute inset-0 bg-black/60"></div>

//       {/* CARD */}
//       <div className="relative z-10 w-full max-w-lg p-6 
//       bg-white/10 backdrop-blur-xl border border-white/30 
//       rounded-2xl text-white">

//         <h2 className="text-2xl font-semibold mb-6 text-center">
//           Return / Replace Product
//         </h2>

//         {/* REASON */}
//         <select
//           value={reason}
//           onChange={(e) => setReason(e.target.value)}
//           className="w-full p-3 mb-4 bg-white/20 border border-white/30 rounded-lg"
//         >
//           <option value="">Select Reason</option>
//           <option>Damaged Product</option>
//           <option>Wrong Item</option>
//           <option>Not satisfied</option>
//           <option>Other</option>
//         </select>

//         {/* REFUND OPTIONS */}
//         <div className="mb-4">
//           <p className="mb-2">Choose Option:</p>

//           <label className="block mb-2">
//             <input
//               type="radio"
//               value="wallet"
//               checked={refundType === "wallet"}
//               onChange={(e) => setRefundType(e.target.value)}
//             />
//             💰 Refund to Wallet
//           </label>

//           <label className="block mb-2">
//             <input
//               type="radio"
//               value="bank"
//               onChange={(e) => setRefundType(e.target.value)}
//             />
//             🏦 Bank Account
//           </label>

//           <label className="block mb-2">
//             <input
//               type="radio"
//               value="exchange"
//               onChange={(e) => setRefundType(e.target.value)}
//             />
//             🔁 Exchange Product
//           </label>
//         </div>

//         {/* BANK INPUT (ONLY IF BANK SELECTED) */}
//         {refundType === "bank" && (
//           <input
//             type="text"
//             placeholder="Enter Bank Details"
//             className="w-full p-3 mb-4 bg-white/20 border border-white/30 rounded-lg"
//           />
//         )}

//         {/* SUBMIT */}
//         <button
//           onClick={handleSubmit}
//           className="w-full bg-white text-black py-3 rounded-lg font-medium"
//         >
//           Submit Request
//         </button>

//       </div>

//     </div>
//   );
// };

// export default ReturnPage;
// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";

// const ReturnPage = () => {
//   const { id } = useParams();

//   const [order, setOrder] = useState(null);
//   const [reason, setReason] = useState("");
//   const [refundType, setRefundType] = useState("wallet");
//   const [bankDetails, setBankDetails] = useState("");
//   const [note, setNote] = useState("");

//   // 🔥 FETCH ORDER DETAILS
//   const fetchOrder = async () => {
//     const res = await fetch(`https://lappyshop.onrender.com/api/order/${id}`, {
//       credentials: "include",
//     });
//     const data = await res.json();
//     if (data.success) setOrder(data.data);
//   };

//   useEffect(() => {
//     fetchOrder();
//   }, []);

//   const handleSubmit = async () => {
//     if (!reason) {
//       alert("Please select reason ❌");
//       return;
//     }

//     const res = await fetch(`/api/return/${id}`, {
//       method: "POST",
//       headers: { "content-type": "application/json" },
//       body: JSON.stringify({
//         reason,
//         refundType,
//         bankDetails,
//         note,
//       }),
//     });

//     const data = await res.json();

//     if (data.success) {
//       alert("Return Request Submitted ✅");
//     }
//   };

//   if (!order) return null;

//   return (
//     <div className="min-h-screen px-4 py-8 bg-gray-100">

//       <div className="max-w-3xl mx-auto">

//         {/* 🔥 PRODUCT CARD */}
//         <div className="bg-white rounded-2xl shadow p-4 mb-6">

//           <h2 className="text-lg font-semibold mb-4">
//             Returning Product
//           </h2>

//           {order.items.map((item) => (
//             <div key={item._id} className="flex gap-4 items-center border-b pb-3 mb-3">

//               <img
//                 src={item.productId.productImage?.[0]}
//                 className="w-20 h-20 object-contain"
//               />

//               <div className="flex-1">
//                 <p className="font-medium">
//                   {item.productId.productName}
//                 </p>
//                 <p className="text-sm text-gray-500">
//                   Qty: {item.quantity}
//                 </p>
//               </div>

//             </div>
//           ))}

//         </div>

//         {/* 🔥 FORM */}
//         <div className="bg-white rounded-2xl shadow p-6">

//           <h2 className="text-xl font-semibold mb-5">
//             Return Details
//           </h2>

//           {/* REASON */}
//           <select
//             value={reason}
//             onChange={(e) => setReason(e.target.value)}
//             className="w-full p-3 border rounded-lg mb-4"
//           >
//             <option value="">Select Reason</option>
//             <option>Damaged Product</option>
//             <option>Wrong Item Delivered</option>
//             <option>Product Not as Expected</option>
//             <option>Other</option>
//           </select>

//           {/* OPTIONS */}
//           <div className="mb-4">
//             <p className="font-medium mb-2">Choose Option:</p>

//             <label className="block mb-2">
//               <input
//                 type="radio"
//                 value="wallet"
//                 checked={refundType === "wallet"}
//                 onChange={(e) => setRefundType(e.target.value)}
//               />
//               💰 Refund to Wallet (Instant)
//             </label>

//             <label className="block mb-2">
//               <input
//                 type="radio"
//                 value="bank"
//                 onChange={(e) => setRefundType(e.target.value)}
//               />
//               🏦 Refund to Bank (2-3 days)
//             </label>

//             <label className="block mb-2">
//               <input
//                 type="radio"
//                 value="exchange"
//                 onChange={(e) => setRefundType(e.target.value)}
//               />
//               🔁 Exchange Product
//             </label>
//           </div>

//           {/* BANK DETAILS */}
//           {refundType === "bank" && (
//             <input
//               type="text"
//               placeholder="Enter Account No / IFSC"
//               value={bankDetails}
//               onChange={(e) => setBankDetails(e.target.value)}
//               className="w-full p-3 border rounded-lg mb-4"
//             />
//           )}

//           {/* NOTE */}
//           <textarea
//             placeholder="Additional Note (optional)"
//             value={note}
//             onChange={(e) => setNote(e.target.value)}
//             className="w-full p-3 border rounded-lg mb-4"
//           />

//           {/* BUTTON */}
//           <button
//             onClick={handleSubmit}
//             className="w-full bg-black text-white py-3 rounded-xl hover:bg-gray-800"
//           >
//             Submit Return Request
//           </button>

//         </div>

//       </div>

//     </div>
//   );
// };

// export default ReturnPage;
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const ReturnPage = () => {
  const { id } = useParams();

  const [order, setOrder] = useState(null);
  const [reason, setReason] = useState("");
  const [refundType, setRefundType] = useState("wallet");
  const [bankDetails, setBankDetails] = useState("");
  const [note, setNote] = useState("");

  // 🔥 FETCH ORDER
  const fetchOrder = async () => {
    const res = await fetch(
      `https://lappyshop.onrender.com/api/order/${id}`,
      { credentials: "include" }
    );

    const data = await res.json();
    if (data.success) setOrder(data.data);
  };

  useEffect(() => {
    fetchOrder();
  }, [id]);

  // 🔥 SUBMIT
  const handleSubmit = async () => {
    if (!reason) {
      alert("Select reason ❌");
      return;
    }

    if (refundType === "bank" && !bankDetails) {
      alert("Enter bank details ❌");
      return;
    }

    const res = await fetch(`/api/return/${id}`, {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        reason,
        refundType,
        bankDetails,
        note,
      }),
    });

    const data = await res.json();

    if (data.success) {
      alert("Return Request Submitted ✅");
    }
  };

  if (!order) return <p className="text-center mt-10">Loading...</p>;

  return (
    <div className="min-h-screen bg-gray-100 px-4 py-8">

      <div className="max-w-3xl mx-auto">

        {/* 🔥 PRODUCT */}
        <div className="bg-white p-5 rounded-2xl shadow mb-6">

          <h2 className="text-lg font-semibold mb-4">
            Returning Product
          </h2>

          {order.items.map((item) => (
            <div key={item._id} className="flex gap-4 mb-3">

              <img
                src={item.productId.productImage?.[0]}
                className="w-20 h-20 object-contain"
              />

              <div>
                <p className="font-medium">
                  {item.productId.productName}
                </p>
                <p className="text-sm text-gray-500">
                  Qty: {item.quantity}
                </p>
              </div>

            </div>
          ))}

        </div>

        {/* 🔥 FORM */}
        <div className="bg-white p-6 rounded-2xl shadow">

          <h2 className="text-xl font-semibold mb-5">
            Return Details
          </h2>

          {/* REASON */}
          <select
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            className="w-full p-3 border rounded-lg mb-4"
          >
            <option value="">Select Reason</option>
            <option>Damaged Product</option>
            <option>Wrong Item</option>
            <option>Not satisfied</option>
            <option>Other</option>
          </select>

          {/* OPTIONS */}
          <div className="mb-4">

            <label className="block mb-2">
              <input
                type="radio"
                value="wallet"
                checked={refundType === "wallet"}
                onChange={(e) => setRefundType(e.target.value)}
              />
              💰 Wallet Refund
            </label>

            <label className="block mb-2">
              <input
                type="radio"
                value="bank"
                onChange={(e) => setRefundType(e.target.value)}
              />
              🏦 Bank Refund
            </label>

            <label className="block mb-2">
              <input
                type="radio"
                value="exchange"
                onChange={(e) => setRefundType(e.target.value)}
              />
              🔁 Exchange
            </label>

          </div>

          {/* BANK */}
          {refundType === "bank" && (
            <input
              type="text"
              placeholder="Account No / IFSC"
              value={bankDetails}
              onChange={(e) => setBankDetails(e.target.value)}
              className="w-full p-3 border rounded-lg mb-4"
            />
          )}

          {/* NOTE */}
          <textarea
            placeholder="Additional note"
            value={note}
            onChange={(e) => setNote(e.target.value)}
            className="w-full p-3 border rounded-lg mb-4"
          />

          {/* BUTTON */}
          <button
            onClick={handleSubmit}
            className="w-full bg-black text-white py-3 rounded-xl"
          >
            Submit Return
          </button>

        </div>

      </div>

    </div>
  );
};

export default ReturnPage;